import {
  applyMiddleware, combineReducers, compose, createStore,
} from 'redux';
import thunk from 'redux-thunk';
import { routerMiddleware, connectRouter } from 'connected-react-router';
import { persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import * as User from './modules/User';
import * as Publication from './modules/Publication';
import * as Branch from './modules/Branch';
import * as CouponCampaign from './modules/CouponCampaign';
import * as Email from './modules/Email';
import * as Notification from './modules/Notification';
import * as Image from './modules/Image';

export default function configureStore(history, initialState) {
  const reducers = {
    user: User.reducer,
    publication: Publication.reducer,
    branch: Branch.reducer,
    couponCampaign: CouponCampaign.reducer,
    notification: Notification.reducer,
    email: Email.reducer,
    image: Image.reducer,
  };

  const middleware = [thunk, routerMiddleware(history)];

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
    enhancers.push(window.devToolsExtension());
  }

  const appReducer = combineReducers({
    ...reducers,
  });

  const rootReducer = (state, action) => {
    if (action.type === User.requestLogoutType) {
      return appReducer(undefined, action);
    }

    return appReducer(state, action);
  };

  const persistConfig = {
    key: 'root',
    storage: storageSession,
    blacklist: ['notification'],
  };
  const persistedReducer = persistReducer(persistConfig, connectRouter(history)(rootReducer));

  return createStore(
    connectRouter(history)(persistedReducer),
    initialState,
    compose(
      applyMiddleware(...middleware),
      ...enhancers,
    ),
  );
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js